import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {LayoutService} from '@utils/services/layout/layout.service';

@Injectable({
  providedIn: 'root'
})
export class HideLayoutGuard implements CanActivate {

  constructor( private layoutService: LayoutService ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.layoutService.hideLayout();
    return true;
  }

}
